<template>
	<div>
		<page-summary v-if="event" :event="event" headerText="Ticket Summary"></page-summary>
		<attendees-booking></attendees-booking>
	</div>
</template>

<script>
  import pageSummary from '../main_booking/page-summary.vue'
  import attendeesBooking from './attendees-booking.vue'

  export default {
    data: function () {
      return {
        event: this.$store.getters.getEvent
      }
    },

    created() {
//      bounces to route if no event
      if (!this.event) this.$router.push('home')
    },

    components: {
      pageSummary: pageSummary,
      attendeesBooking: attendeesBooking
    }
  }
</script>
